import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import GetRandomKey from '../../../../components/general/genereRandomKey';
import { Checkbox } from '@material-ui/core';

const FilterComponent = forwardRef(({ data, onChange, name }, ref) => {
  const [chechSelectAll, setcheckSelectAll] = useState(true);
  const [cloneData, setClonedata] = useState(data);

  useImperativeHandle(ref, () => {
    return {
      reset(selectedEdition) {
        if (Array.isArray(selectedEdition)) {
          setClonedata((prev) => {
            let retournArray = [];
            for (const prevItem of prev) {
              const existeDansEdition = selectedEdition.some((item) => item.id === prevItem.editionId && item.check);
              retournArray.push({ ...prevItem, display: existeDansEdition, check: existeDansEdition });
            }
            return retournArray;
          });
        } else {
          console.error("selectedEdition is not an array probablement il est null ", selectedEdition);
        }
      },
    };
  }, []);  

const handleSelectAll = () => {
  setcheckSelectAll((prevSelectAll) => {
    const newSelectAll = !prevSelectAll;
    setClonedata((prev) => {
      let retournArray = [];
      for (const prevItem of prev) {
        retournArray.push({ ...prevItem, check: newSelectAll });
      }
      onChange(retournArray);
      return retournArray;
    });
    return newSelectAll;
  });
};

const handleItemChange = (item) => {
  setClonedata((prev) => {
    const indexToUpdate = prev.findIndex((prevItem) => {
      if (prevItem.editionId) {
        return prevItem.id === item.id && prevItem.editionId === item.editionId;
      }
      return prevItem.id === item.id;
    });

    if (indexToUpdate !== -1) {
      const updatedItem = { ...prev[indexToUpdate], check: !prev[indexToUpdate].check };
      const newArray = [...prev.slice(0, indexToUpdate), updatedItem, ...prev.slice(indexToUpdate + 1)];
      onChange(newArray);
      return newArray;
    }

    return prev;// Si l'élément n'est pas trouvé, retournez l'array existant sans modification
  });

};


useEffect(() => {
  setClonedata((prev) => {
    let retournArray = [];
    for (const prevItem of prev) {
      retournArray.push({ ...prevItem, display: true, check: true });
    }
    return retournArray;
  });
}, []);

useEffect(() => {
  setcheckSelectAll(!cloneData.some((item) => item.check === false))// si il existe un nonCheck selectAll est nonCheck  
}, [cloneData])


return (
  <div style={{ maxHeight: 200, overflow: 'auto' }}>
    <h3 style={{ textAlign: 'center' }}>{name}</h3>
    <label>
      <Checkbox type="checkbox" checked={chechSelectAll} onChange={handleSelectAll} />
      Tous
    </label>
    {cloneData.map((item) => {
      return (
        <div key={GetRandomKey(12)}>
          <label className={item?.display ? 'checkBoxFilter' : 'checkBoxFilter hide'}>
            <Checkbox
              type="checkbox"
              checked={item.check}
              onChange={() => handleItemChange(item)}
              label="Start"
            />
            {item.name}
          </label>
        </div>
      )
    })}
  </div>
);
});

export default FilterComponent;
